import React from 'react';
import { ArrowStyles, CardContainerStyles, DialogContainerStyles, VisualizationImagesArrowsContainer, VisualizationImagesSelection, VisualizationImagesStyles, VisualizationStyles } from './InputImage.styles';
import Icon from '../Icon';
import Card from '../Card/Card';
import { elo as theme } from '../../themes';
import Pagination from '../Pagination/Pagination';
import Dialog from '../Dialog/Dialog';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FileVisualizationDialog = function FileVisualizationDialog(_ref) {
  var _files$currentImageIn, _files$currentImageIn2, _files$currentImageIn3;
  var currentImageIndex = _ref.currentImageIndex,
    files = _ref.files,
    setCurrentImageIndex = _ref.setCurrentImageIndex;
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  if (!files || !files.length || currentImageIndex === null) {
    return null;
  }
  return ___EmotionJSX(Dialog, {
    title: (_files$currentImageIn = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn.name,
    onClose: function onClose() {
      return setCurrentImageIndex(null);
    },
    size: "large"
  }, ___EmotionJSX(DialogContainerStyles, null, ___EmotionJSX(ArrowStyles, {
    style: {
      left: isMobile ? '8px' : '0',
      visibility: currentImageIndex > 0 ? 'inherit' : 'hidden'
    },
    onClick: function onClick() {
      return setCurrentImageIndex(function (index) {
        return index - 1;
      });
    }
  }, ___EmotionJSX(Icon, {
    type: "chevron-left",
    variant: "brand"
  })), ___EmotionJSX(CardContainerStyles, null, ___EmotionJSX(Card, {
    secondary: true
  }, ___EmotionJSX(VisualizationImagesArrowsContainer, null, ___EmotionJSX(VisualizationStyles, {
    src: (_files$currentImageIn2 = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn2.src,
    alt: (_files$currentImageIn3 = files[currentImageIndex]) == null ? void 0 : _files$currentImageIn3.name
  })))), ___EmotionJSX(ArrowStyles, {
    style: {
      right: isMobile ? '8px' : '0',
      visibility: currentImageIndex < files.length - 1 ? 'inherit' : 'hidden'
    },
    onClick: function onClick() {
      return setCurrentImageIndex(function (index) {
        return index + 1;
      });
    }
  }, ___EmotionJSX(Icon, {
    type: "chevron-right",
    variant: "brand"
  }))), ___EmotionJSX(VisualizationImagesSelection, {
    style: {
      margin: isMobile ? theme.spacings.xxSmall + " auto 0" : ''
    }
  }, isMobile ? ___EmotionJSX(Pagination, {
    initialPage: currentImageIndex + 1,
    itemsPerPage: 1,
    totalItems: files.length,
    type: "mobile",
    onClickMobilePageItem: function onClickMobilePageItem(e) {
      return setCurrentImageIndex(e - 1);
    }
  }) : files.map(function (file, i) {
    return ___EmotionJSX(VisualizationImagesStyles, {
      key: i,
      onClick: function onClick() {
        return setCurrentImageIndex(i);
      },
      style: {
        backgroundImage: "url(" + (file == null ? void 0 : file.src) + ")",
        border: currentImageIndex === i ? "2px solid " + theme.colors.brand40 : "2px solid " + theme.colors.shade20
      }
    });
  })));
};
FileVisualizationDialog.propTypes = {
  currentImageIndex: PropTypes.number.isRequired,
  files: PropTypes.array.isRequired,
  setCurrentImageIndex: PropTypes.func.isRequired
};
export default FileVisualizationDialog;